import { ChangeEvent, useEffect } from 'react'
import { Input, Stack } from '@chakra-ui/react'

import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import validateMailOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validateMailOnCustomForm'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import useCustomFormGetDefaultValue from '../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormMailQuestion({
  question,
  questionKey,
  disabled,
  formMethods,
}: CustomFormViewerQuestionProps) {
  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  const questionWithError = thisQuestionHasError(question.slug)?.question

  function validateMailQuestion(mail: string) {
    const errorMessage = validateMailOnCustomForm({ mail, isRequired: question.is_required })
    if (errorMessage === '') {
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  function handleOnBlur(event: ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value
    validateMailQuestion(inputValue)
  }

  useEffect(() => {
    if (defaultValue) {
      validateMailQuestion(defaultValue)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <Input
        id={question.slug}
        isDisabled={disabled}
        placeholder={question?.placeholder}
        value={formMethods?.watch ? formMethods.watch(questionKey) : defaultValue}
        {...(formMethods?.register && formMethods.register(questionKey, { onBlur: handleOnBlur }))}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />
    </Stack>
  )
}
